import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';

import ChatContextInput from 'entity/ChatContextInput';
import ChatInput from 'entity/ChatInput';
import ChatOutput from 'entity/ChatOutput';
import ChatStateUpdate from 'entity/ChatStateUpdate';

import ChatbotController from 'rest/ChatbotController';

@Injectable({
  providedIn: 'root',
})
export class ChatbotService {
  private chatbotController: ChatbotController;

  public constructor() {
    this.chatbotController = new ChatbotController();
  }

  /**
   * Called once per session to register context.
   * @param input Context information for the chat session.
   * @returns Observable that completes when the session is initialized.
   */
  public async initializeSession(input: ChatContextInput): Promise<void> {
    return await this.chatbotController.initializeSession(input);
  }

  /**
   * Sends a user message during an active chat and returns a reply.
   * @param input The user's message input.
   * @returns Observable emitting the chatbot's reply.
   */
  public async sendMessage(input: ChatInput): Promise<ChatOutput> {
    return await this.chatbotController.sendMessage(input);
  }

  /**
   * Updates live session state (mic/video/group/etc).
   * @param input The state update information.
   * @returns Observable that completes when the state is updated.
   */
  public async updateState(input: ChatStateUpdate): Promise<void> {
    return await this.chatbotController.updateState(input);
  }
}
